export default "__VITE_ASSET__B3M9O6Ob__"